import { Control, Controller } from "react-hook-form";
import { Tool } from "../AssistantDetailsContent";
import { AgentsField } from "../AgentsField";
import { NoxusFormEntryConfig } from "@/components/Spotflow/ConfigDrawer/ConfigDrawer";

export const CoworkersFieldNCL = ({
  name,
  control,
  isDisabled,
  defaultValue,
  itemConfig,
}: {
  name: string;
  control: Control<Record<string, unknown>>;
  isDisabled?: boolean;
  defaultValue?: unknown;
  itemConfig?: Record<string, NoxusFormEntryConfig>;
}) => {
  return (
    <Controller
      control={control}
      name={name}
      defaultValue={defaultValue}
      render={({ field }) => {
        const value = field.value as Tool[] | undefined;
        return (
          <AgentsField
            tools={value}
            onToolsChange={field.onChange}
            isDisabled={isDisabled}
            itemConfig={itemConfig}
          />
        );
      }}
    />
  );
};
